export const CALCULATOR_RUNTIME_MANIFEST_SCHEMA_VERSION = 1;
export const CALCULATOR_RUNTIME_MANIFEST_URL =
  "/calculator/runtime/runtime-manifest.json";

const EXACT_KEYS = ["engineVersion", "module", "schemaVersion", "wasm"];
const ENGINE_VERSION_RE = /^[a-z0-9][a-z0-9._-]*$/;
const MODULE_PATH_RE =
  /^\/calculator\/runtime\/fishystuff_calculator\.[0-9a-f]{16}\.js$/;
const WASM_PATH_RE =
  /^\/calculator\/runtime\/fishystuff_calculator_bg\.[0-9a-f]{16}\.wasm$/;

function requireRecord(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    throw new TypeError("calculator runtime manifest must be an object");
  }
  return value;
}

function requireExactKeys(value) {
  const keys = Object.keys(value).sort();
  if (
    keys.length !== EXACT_KEYS.length
    || keys.some((key, index) => key !== EXACT_KEYS[index])
  ) {
    throw new TypeError(
      `calculator runtime manifest fields must be exactly: ${EXACT_KEYS.join(", ")}`,
    );
  }
}

function requireEngineVersion(value) {
  if (typeof value !== "string" || !ENGINE_VERSION_RE.test(value)) {
    throw new TypeError("calculator runtime manifest engineVersion is invalid");
  }
  return value;
}

function requireAssetPath(value, pattern, field) {
  if (typeof value !== "string" || !pattern.test(value)) {
    throw new TypeError(`calculator runtime manifest ${field} path is invalid`);
  }
  return value;
}

export function parseCalculatorRuntimeManifest(value) {
  const manifest = requireRecord(value);
  requireExactKeys(manifest);
  if (manifest.schemaVersion !== CALCULATOR_RUNTIME_MANIFEST_SCHEMA_VERSION) {
    throw new TypeError(
      `unsupported calculator runtime manifest schemaVersion: ${String(manifest.schemaVersion)}`,
    );
  }

  return Object.freeze({
    schemaVersion: CALCULATOR_RUNTIME_MANIFEST_SCHEMA_VERSION,
    engineVersion: requireEngineVersion(manifest.engineVersion),
    module: requireAssetPath(manifest.module, MODULE_PATH_RE, "module"),
    wasm: requireAssetPath(manifest.wasm, WASM_PATH_RE, "wasm"),
  });
}

export function createCalculatorRuntimeManifest({ engineVersion, module, wasm }) {
  return parseCalculatorRuntimeManifest({
    schemaVersion: CALCULATOR_RUNTIME_MANIFEST_SCHEMA_VERSION,
    engineVersion,
    module,
    wasm,
  });
}
